import { Middleware } from 'redux';
import { BasketErrorModel, BasketApiErrorModel } from 'models/Errors';
import { BasketActionTypes } from 'store/basket';
import { ERROR_ACTION_TYPE_POSTFIX } from './constants';

const API_AUTH_ERROR_STATUS = 401;

export const authErrorHandlerMiddleware: Middleware = store => next => action => {
    if (action.type?.endsWith(ERROR_ACTION_TYPE_POSTFIX) && action.error && isApiAuthError(action.error)) {
        store.dispatch({ type: BasketActionTypes.HANDLE_API_AUTH_ERROR_REQUEST });
    }

    return next(action);
};

function isApiAuthError(error: BasketErrorModel | BasketApiErrorModel): boolean {
    if (error instanceof BasketApiErrorModel && error.responseStatus === API_AUTH_ERROR_STATUS) {
        return true;
    }

    let innerError = getInnerError(error);
    while (innerError !== null) {
        if (innerError instanceof BasketApiErrorModel && innerError.responseStatus === API_AUTH_ERROR_STATUS) {
            return true;
        }

        innerError = getInnerError(innerError);
    }

    return false;
}

function getInnerError(error: BasketErrorModel | Error): BasketErrorModel | null {
    if (error instanceof BasketErrorModel && error.innerError && error.innerError instanceof BasketErrorModel) {
        return error.innerError;
    }

    return null;
}